let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a8qer")).then(() => parcelRequire('1k6MX'));